import { useMemo, useCallback } from "react";

import {
  useModalVisibilityControl,
  ModalVisibilityConfig,
} from "./useModalVisibilityControl";

export function useAddressRegistrationModal() {
  const config: ModalVisibilityConfig = useMemo(
    () => ({
      storageKey: "hideAddressRegistrationModal",
      lastClosedKey: "addressRegistrationModalLastClosed",
      temporaryHideDuration: 1,
      temporaryHideUnit: "days" as const,
    }),
    [],
  );

  const { setHideModal, setTemporaryHide, isLoaded, createShouldShowModal } =
    useModalVisibilityControl(config);

  const shouldShowModal = useCallback(
    (hasAddress: boolean) => {
      // カスタム条件を作成
      const customCondition = () => {
        // 住所が未登録の場合は表示
        return !hasAddress;
      };

      // 共通ロジックにカスタム条件を適用
      return createShouldShowModal(customCondition)();
    },
    [createShouldShowModal],
  );

  return {
    shouldShowModal,
    setHideModal,
    setTemporaryHide,
    isLoaded,
  };
}
